module.exports = __webpack_public_path__ + "static/media/Path 34add.7b67a309.svg";